import { Disciplinary, PagedResultOfDisciplinary, SaveDisciplinaryRequest, api } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { getPaginationParameters } from 'utils';

type DisciplinaryListParams = TableState<Disciplinary, undefined> & { examinerId: number };

const disciplinaryApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getDisciplinaries: builder.query<PagedResultOfDisciplinary, DisciplinaryListParams>({
      query: ({ examinerId, ...params }) => {
        return api.disciplinary.getDisciplinaries({
          ...getPaginationParameters(params),
          examinerId,
        });
      },
      providesTags: ['Disciplinary'],
    }),

    saveDisciplinary: builder.mutation<void, { examinerId: number; data: SaveDisciplinaryRequest }>(
      {
        query: ({ examinerId, data }) => api.disciplinary.saveDisciplinary({ examinerId }, data),
        invalidatesTags: ['Disciplinary', 'ExaminerStatus'],
      }
    ),
  }),
});

export const { useGetDisciplinariesQuery, useSaveDisciplinaryMutation } = disciplinaryApi;
